export const COOKIES = {
    LANGUAGE: 'language',
    SESSION_TYPE: 'bfsd',
    JUST_LOGGED_IN: 'justLoggedIn',
    VISITOR_ID: 'vid',
    AUTOMATED_TEST_FLAG_COOKIE: 'automatedTest',
    AUTH_TOKEN: 'X-Auth-Token',
    LOGIN_TOKEN: 'X-Login-Token',
    MFA_TOKEN: 'X-MFA-Token',
    CURRENCY: 'X-Currency',
    REGION: 'X-Region',
    CPP_REGION: 'X-Cpp-Region',
    PLATFORM: 'X-Platform',
    USER_AGENT: 'X-User-Agent',
    BROWSER_STACK_NETWORK_PROFILE: 'X-BStack-Network-Profile', // 3G,4G etc
    BROWSER_STACK_DEVICE_PERFORMANCE: 'X-BStack-Device-Performance', // low/mid/high
    BROWSER_STACK_AUTOMATION_TAG: 'X-BStack-Automation-Tag', // Traffic Generation etc.
    SHOULD_DISPLAY_REGION_SELECTOR: 'X-Should-Display-Region-Selector',
    SPORTSBOOK_REGION: 'X-Sportsbook-Region',
    USER_ID: 'User-ID',
    LAST_USER_ID: 'Last-User-ID',
    DISTRIBUTION_METHOD: 'distributionMethod',
    SHOW_ALL_REGIONS_TOKEN: 'x-show-all-regions-token',
    WRAPPER: 'wrapper',
    PX_AUTHORIZATION_TOKEN: '_px3',
    BTAG: 'btag',
    PRISMIC_COOKIE: 'io.prismic.preview',
    SESSION_ID: 'Session-ID',
    REFERER_REDIRECT: 'referrer-redirect',
    DISPLAY_XSELL_BOTTOM_NAV: 'display_xsell_bottom_nav',
    IS_NEW_HEADER_LAYOUT: 'isNewHeaderLayout',
    AMP_SESSION_ID: 'amp_session_id',
    AMP_DEVICE_ID: 'amp_device_id',
    TRACKING_ENV: 'tracking_env',
    IS_TILE_ENHANCED: 'enhanced-layout',
    FIRST_ARRIVAL: 'firstArrival',
    REWARD_MACHINE_WELCOME: 'reward-machine-welcome',
    THEME: 'theme',
    IS_SYSTEM_THEME: 'is_system_theme',
    BRAZE_DEVICE_ID: 'brazeDeviceId',
    POKER_DEV_ACCESS: 'poker-dev-access',
    X_GEOLOCATION_TOKEN: 'X-Geocomply-Token',
    USE_GAME_WINDOW: 'useGameWindow',
    ANDROID_NATIVE_HEADER: 'X-Hide-Header'
};
